<template>
  <div>
    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Cari Ekle/Güncelle"
      size="lg"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Cari Adı"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>

                  <b-col cols="4">
                    <b-form-input
                      id="h-first-name"
                      :disabled="degerKontrol == true"
                      v-model="cariName"
                    />
                  </b-col>
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Cari Kodu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>

                  <b-col cols="4">
                    <b-form-input
                      id="h-first-name"
                      :disabled="degerKontrol == true"
                      v-model="ACTNO"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Adres 1"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="ADDRESS1" />
                  </b-col>
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Adres 2"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="ADDRESS2" />
                  </b-col>
                </b-row>

                <b-row style="margin-bottom: 10px">
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Sehir"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="CITY" />
                  </b-col>
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Ülke"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="COUNTRY" />
                  </b-col>
                </b-row>

                <b-row style="margin-bottom: 10px">
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="E mail"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="EMAIL" />
                  </b-col>
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Telefon"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="GSM" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="TC NO"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="TCNO" />
                  </b-col>
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Web Adresi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="WEB" />
                  </b-col>
                </b-row>

                <b-row style="margin-bottom: 10px">
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Vergi No"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="TAXNO" />
                  </b-col>
                  <b-col cols="2" align-self="center">
                    <b-form-group
                      label="Vergi Dairesi"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-input id="h-first-name" v-model="TAXOFFICE" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="2" align-self="start">
                    <b-form-group
                      label="Grup Kodu"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <v-select
                      :color="select2"
                      v-model="grupkodSecilen"
                      :options="grupkod"
                      @input="changedLabel"
                      style="
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                      "
                      autocomplete
                      ref="selectElement"
                    >
                    </v-select>
                  </b-col>
                  <b-col cols="2" align-self="start">
                    <b-form-group
                      label="Açıklama"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <vs-textarea label="Açıklama" v-model="textareaNot" />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
           <vs-button
            style="border-radius: 5px"
            type="gradient"
            color="danger"
            class="float-right"
            @click="cancel()"
            >İptal</vs-button
          >

          <vs-button
            style="border-radius: 5px"
            type="gradient"
            color="success"
            class="float-right"
            @click="stokKaydet()"
            >Kaydet</vs-button
          >
          
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import vSelect from "vue-select";
import moment from "moment";
export default {
  data() {
    return {
      inputValFiyat: "",
      select2: "primary",
      grupkod: ["Ara Karton", "Etiket", "Ön Karton"],
      grupkodSecilen: "",
      cariName: "",
      ADDRESS1: "",
      ADDRESS2: "",
      ADDRESS3: "",
      ACTID: "",
      ACTNAME: "",
      ACTNO: "",
      ADDRESS1: "",
      ADDRESS2: "",
      ADDRESS3: "",
      CITY: "",
      CONTACTNAME: "",
      COUNTRY: "",
      DESCRIPTION: "",
      EMAIL: "",
      GROUPCODE: "",
      GSM: "",
      STATUS: "",
      TAXNO: "",
      TAXOFFICE: "",
      TCNO: "",
      TOWN: "",
      WEB: "",
      stokNo: "",
      barkod: "",
      stokAdi: "",
      textareaNot: "",
      query: "",
      querystok: "",
      filteredOptions: [],
      filteredOptionsstok: [],
      datasuggest: [],
      datasuggeststok: [],
      birimAgırlık: "",
      ACTNAME: "",
      gelenSTOCKNO: "",
      gelenSTOCKID: "",
      gelenSTOCKNAME: "",
      stokIdSecilen: "",
      RECEIPTID: "",
      ITEMNO: "",
      birimSecilen: "",
      birim: ["Adet", "Kg", "Metre", "Ton"],
      degerKontrol: false,
      stokID: "",
    };
  },

  components: { "v-select": vSelect },
  methods: {
    changedLabel(event) {
      console.log(event);
    },

    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    cancel() {
      this.$refs["modal-primary "].hide();
      this.stokID = "";
      this.stokNo = "";
      this.barkod = "";
      this.stokAdi = "";
      this.grupkodSecilen = "";
      this.birimAgırlık = "";
      this.birimSecilen = "";
      this.textareaNot = "";
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    stokKaydet() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.ACTNO == "") {
        vs.notify({
          title: "Cari",
          text: "Cari Kodu alanı boş olmamalı",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          ISLEM: "INSERT",
          ARANAN: "",
          STATUS: "2",

          //ACT için
          ACTID: vm.ACTID,
          ACTNO: vm.ACTNO,
          ACTNAME: vm.cariName,
          GROUPCODE: vm.grupkodSecilen,
          DESCRIPTION: vm.textareaNot,
          CONTACTNAME: "",
          GSM: vm.GSM,
          EMAIL: vm.EMAIL,
          WEB: vm.WEB,
          ADDRESS1: vm.ADDRESS1,
          ADDRESS2: vm.ADDRESS2,
          ADDRESS3: "",
          TOWN: vm.TOWN,
          CITY: vm.CITY,
          COUNTRY: vm.COUNTRY,
          TAXOFFICE: vm.TAXOFFICE,
          TAXNO: vm.TAXNO,
          TCNO: vm.TCNO,
          INSERTUSERID: Store.state.UserId,
          EDITUSERID: Store.state.UserId,
        };
        soap.createClient(url, function (err, client) {
          client.UZM_ACTINS(args, function (err, result) {
            if (result.UZM_ACTINSResult == "-1") {
              Store.dispatch("logout");
            }
            console.log(result);
            try {
              if (result.UZM_ACTINSResult == "Yes") {
                vm.$root.$emit("carilistele");
                vs.notify({
                  title: "Cari",
                  text: "Cari kaydı tamamlandı.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                vm.$refs["modal-primary "].hide();
                vm.cariName = "";
                vm.ACTID = "";
                vm.ACTNO = "";
                vm.GSM = "";
                vm.EMAIL = "";
                vm.grupkodSecilen = "";
                vm.ADDRESS1 = "";
                vm.ADDRESS2 = "";
                vm.TOWN = "";
                vm.CITY = "";
                vm.COUNTRY = "";
                vm.TAXOFFICE = "";
                vm.TAXNO = "";
                vm.TCNO = "";

                vm.textareaNot = "";
              } else {
                vs.notify({
                  title: "Cari",
                  text: "Cari kaydında hata oluştu. " + result.UZM_ACTINSResult,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
              //   vm.rowData = vm.veriler;
            } catch (error) {
              console.log(error);
            }
          });
        });
      }
    },
    stokDetayComponent(gelen) {
      this.$refs["modal-primary "].show();
      if (typeof gelen != "undefined") {
        this.degerKontrol = true;
        this.cariName = gelen.ACTNAME;
        this.ACTID = gelen.ACTID;
        this.ACTNO = gelen.ACTNO;
        this.ADDRESS1 = gelen.ADDRESS1;
        this.ADDRESS2 = gelen.ADDRESS2;
        this.ADDRESS3 = gelen.ADDRESS3;

        this.CITY = gelen.CITY;
        this.CONTACTNAME = gelen.CONTACTNAME;
        this.COUNTRY = gelen.COUNTRY;
        this.DESCRIPTION = gelen.DESCRIPTION;
        this.EMAIL = gelen.EMAIL;
        this.GROUPCODE = gelen.GROUPCODE;
        this.GSM = gelen.GSM;
        this.STATUS = gelen.STATUS;
        this.TAXNO = gelen.TAXNO;
        this.TAXOFFICE = gelen.TAXOFFICE;
        this.TCNO = gelen.TCNO;
        this.TOWN = gelen.TOWN;
        this.WEB = gelen.WEB;
        this.grupkodSecilen = gelen.GROUPCODE;
        this.birimSecilen = gelen.BIRIM;
        this.birimAgırlık = gelen.BIRIMAGIRLIK;
        this.stokID = gelen.STOCKID;
      }
    },
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}
[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}
[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}
.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 100px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}
</style>